import { render, staticRenderFns } from "./InvD.vue?vue&type=template&id=cc351d8a"
import script from "./InvD.vue?vue&type=script&lang=js"
export * from "./InvD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports